module.exports = __webpack_public_path__ + "media/images/prestaciones/mujer-1a7fd7c9f0015eb4ac28dacc815fda11.svg";